import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UpgradePlanComponent} from './upgrade-plan/upgrade-plan.component';

@NgModule({
    declarations: [
        UpgradePlanComponent,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        UpgradePlanComponent
    ]
})
export class MessagesModule {
}
